import { AnalyticsFilter, AnalyticsCSVFilter } from './types';

export const isAnalyticsFilter = (value: string): value is AnalyticsFilter => {
  const options: AnalyticsFilter[] = [
    'active',
    'completed',
    'rejected',
    'with_written_review',
    'with_rating_1',
    'with_rating_2',
    'with_rating_3',
    'with_rating_4',
    'with_rating_5',
  ];
  return (options as string[]).includes(value);
};

export const isAnalyticsCSVFilter = (value: string): value is AnalyticsCSVFilter => {
  const options: AnalyticsCSVFilter[] = [
    'completed',
    'rejected',
    'with_written_review',
    'with_rating_1',
    'with_rating_2',
    'with_rating_3',
    'with_rating_4',
    'with_rating_5',
  ];
  return (options as string[]).includes(value);
};
